import './style.scss';

import classNames from 'classnames';
import { TrackingContext } from 'providers/Tracking';
import TRACKING_EVENTS from 'providers/Tracking/constants';
import TRACKING_EVENT_COLLECTIONS from 'providers/Tracking/trackingEventCollections';
import { forwardRef, memo, ReactNode, Ref, useContext, useEffect } from 'react';

type Props = {
  className?: string;
  isLastPage?: boolean;
  isVisible?: boolean;
  type: 'newsletter' | 'preview' | 'default';
  children?: ReactNode;
  pageId: string;
  isAbTestVerticalScrollActive?: boolean;
};
const Page = forwardRef<HTMLLIElement, Props>(
  (
    {
      type,
      isVisible = false,
      isLastPage = false,
      className = '',
      children,
      pageId,
      isAbTestVerticalScrollActive = false,
    }: Props,
    ref: Ref<HTMLLIElement>,
  ) => {
    const pageClasses = classNames({
      page: true,
      [className]: true,
    });

    const { trackEventUniversalAnalytics, trackEventDataLayerService } =
      useContext(TrackingContext);
    useEffect(() => {
      if (!isAbTestVerticalScrollActive && isVisible && isLastPage) {
        trackEventUniversalAnalytics({ ...TRACKING_EVENTS.FLYER_LASTPAGE_SEEN, eventLabel: type });
        trackEventDataLayerService(TRACKING_EVENT_COLLECTIONS.FLYER_LASTPAGE_SEEN);
      }
    }, [
      isVisible,
      isLastPage,
      isAbTestVerticalScrollActive,
      trackEventUniversalAnalytics,
      type,
      trackEventDataLayerService,
    ]);

    return (
      <li data-pageid={pageId} className={pageClasses} ref={ref}>
        {children}
      </li>
    );
  },
);

export default memo(Page);
